import { courseOverviewActions } from './OverviewAction';

const initState = {
    loadingFlags: {
        "quizzes": true,
        "course": true,
        "final-state": true,
        "progress": true,
        "participation": true
    },
    errors: {},
    examStart: null,
    examEnd: null,
    examStatus: null,
    userExamStatus:null,
    filter: 'all',
    userRates: null
}

export default function overviewPageReducer(state=initState, action) {
    switch (action.type) {
        case courseOverviewActions.setError:
            return setError(state, action);
        case courseOverviewActions.toggleSpinner:
            return toggleSpinner(state, action);
        case courseOverviewActions.setExamData:
            return setExamData(state, action);
        case courseOverviewActions.clearExamData:
            return clearExamData(state, action);
        case courseOverviewActions.setFilterState:
            return setFilterState(state, action);
        case courseOverviewActions.setUserRate:
            return setUserRate(state, action);
        default:
            return state;
    }
}

function setUserRate(state, {payload}) {
    return  {
        ...state,
        userRates: payload
    }
}

function setFilterState(state, {payload}) {
    return {
        ...state,
        filter: payload,
    }
}

function clearExamData(state) {
    return {
        ...state,
        examId: null,
        examStart: null,
        examEnd: null,
        examStatus: null
    }
}

function setExamData(state, {payload}) {
    return {
        ...state, 
        examId: payload.id,
        examStart: payload.start,
        examEnd: payload.end,
        examStatus: payload.status,
        userExamStatus: payload.userExamStatus
    }
}

function setError(state, {payload, meta}) {
    return {
        ...state,
        errors: {
            [meta.apiName]: payload
        },
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.loadingFlags,
            [meta.apiName]: payload,
        },
    }
}